import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ClientAbbreviationsConfigService {
  private abbreviations$: Observable<Record<string, string>>;

  constructor(private firestore: AngularFirestore) {}

  getAbbreviations(): Observable<Record<string, string>> {
    if (!this.abbreviations$) {
      this.abbreviations$ = this.firestore
        .doc('welby_configuration/client_abbreviations')
        .get()
        .pipe(
          map((snap) => (snap.exists ? (snap.data() as Record<string, string>) : {})),
          catchError(() => of({})),
          shareReplay(1)
        );
    }
    return this.abbreviations$;
  }
}
